import NotFound from "./NotFound.md";
import Admin from "./Admin.md";
import PreparationSlip from "./PreparationSlip.md";
import Product from "./Product.md";
import ProductionAndWaste from "./ProductionAndWaste.md";
import DeliverySlip from "./DeliverySlip.md";
import Recipe from "./Recipe.md";
import Supplier from "./Supplier.md";
import TagManager from "./TagManager.md";
import UnitManager from "./UnitManager.md";
import Inventory from "./Inventory.md";
export const markdownContent = [
  {
    text: "NotFound",
    value: NotFound
  },
  {
    text: "Admin",
    value: Admin
  },
  {
    text: "PreparationSlip",
    value: PreparationSlip
  },
  {
    text: "Product",
    value: Product
  },
  {
    text: "ProductionAndWaste",
    value: ProductionAndWaste
  },
  {
    text: "DeliverySlip",
    value: DeliverySlip
  },
  {
    text: "Recipe",
    value: Recipe
  },
  {
    text: "Supplier",
    value: Supplier
  },
  {
    text: "TagManager",
    value: TagManager
  },
  {
    text: "UnitManager",
    value: UnitManager
  },
  {
    text: "Inventory",
    value: Inventory
  }
];
